import EarthIcon from '@/assets/Icons/Earth-Spotnana.svg?react';
import MetricsIcon1 from '@/assets/Icons/Metrics-1.svg?react';
import MetricsIcon2 from '@/assets/Icons/Metrics-2.svg?react';
import MetricsIcon3 from '@/assets/Icons/Metrics-3.svg?react';
import MetricsIcon4 from '@/assets/Icons/Metrics-4.svg?react';
import CertificateIcon from '@/assets/Icons/Certificate.svg?react';
import DownloadFileIcon from '@/assets/Icons/Download-File.svg?react';
import Checklist from '@/assets/Icons/Checklist.svg?react';

export const climateProSideMenuItems = {
	'CO₂ data gap': {
		icon: <Checklist />,
		submenu: {
			'Trip data coverage': { path: '/climate-pro/co2-reporting-quality' },
			Settings: { path: '/climate-pro/co2-reporting-quality-settings' },
		},
	},
	'CO₂ budget': {
		icon: <EarthIcon />,
		submenu: {
			Setting: { path: '/climate-pro/setting' },
			Allocation: { path: '/climate-pro/allocation' },
			'Excess alerts': { path: '/climate-pro/excess-alerts' },
		},
	},
	'CO₂ factor framework': {
		path: '/climate-pro/factor-framework',
		icon: <MetricsIcon1 />,
	},
	'CO₂ metrics': {
		path: '/climate-pro/metrics',
		icon: <MetricsIcon2 />,
	},
	'CO₂ dashboard': {
		path: '/climate-pro/dashboard',
		icon: <MetricsIcon3 />,
	},
	'CO₂ forecast analytics': {
		path: '/climate-pro/analytics',
		icon: <MetricsIcon4 />,
	},
	'CO₂ compensation statement': {
		path: '/climate-pro/certificates',
		icon: <CertificateIcon />,
	},
	'CO₂ report downloads': {
		path: '/climate-pro/report',
		icon: <DownloadFileIcon />,
	},
};
